import config from 'app-config'
import actions from 'redux/actions'
import request from 'sb-request'
import { getCookieValue } from 'helpers'
import { reducers, getState } from 'redux/core'
import { constants, getGqlQuery } from 'common/helpers'


const fetchProducts = () => {
  const testProductIds = {
    freProduct: [ 2129 ],
    zirhProduct: [ 2101 ],
    purlisseProduct: [ 2123 ],
    pathcologyProduct1: [ 2352 ],
    patchologyProduct2: [ 2350 ],
    saturdaySkinProduct: [ 2127 ],
    wanderBeautyProduct: [ 1671 ],
    codeOfHarmonyProduct: [ 2394 ],
    theBetterSkinCoProduct: [ 2135 ],
    purlisseProductsBanner: [ 2108, 2107, 2109 ],
    scentbirdProductsBanner: [ 1631, 1632, 1636 ],
  }

  const prodProductIds = {
    freProduct: [ 1128 ],
    zirhProduct: [ 1152 ],
    purlisseProduct: [ 1144 ],
    pathcologyProduct1: [ 1320 ],
    patchologyProduct2: [ 1137 ],
    saturdaySkinProduct: [ 1145 ],
    wanderBeautyProduct: [ 1077 ],
    codeOfHarmonyProduct: [ 1177 ],
    theBetterSkinCoProduct: [ 1149 ],
    purlisseProductsBanner: [ 1142, 1141, 1143 ],
    scentbirdProductsBanner: [ 1105, 1104, 1106 ],
  }

  const productIds = config.runEnv !== 'prod' ? testProductIds : prodProductIds

  const query = Object.keys(productIds).map((productType) => {
    const productsQuery = getGqlQuery('products', {
      includeProducts: productIds[productType],
    })

    return `${productType}: ${productsQuery} {
      id
      img
      name
      brand
      retailPriceForcedVisibility
      upchargePrice
    }`
  }).join('')

  return (
    request.post('graphql?name=fetchSkincareIntroProducts', {
      withErrorModal: false,
      body: {
        query: `{
          ${query}
        }`,
      },
    })
      .then((products) => reducers.view.skincareIntroPage.setProducts(products))
  )
}

const selectItem = (item) => {
  reducers.view.skincareIntroPage.selectItem(item)
  saveSelectedItems()
}

/**
 * Saves selected items to localStorage
 */
const saveSelectedItems = () => {
  const { view: { skincareIntroPage: { selectedItems } } } = getState()

  actions.misc.localStorage.setItem(constants.localStorageNames.skincareIntroItems, selectedItems)
}

/**
 * Clear selected items from store
 */
const clearSelectedItems = () => {
  actions.misc.localStorage.removeItem(constants.localStorageNames.skincareIntroItems)
  reducers.view.skincareIntroPage.clearItems()
}

const moveSelectedItemsFromCookieToStorage = () => {
  const selectedItems = (getCookieValue(constants.cookieNames.postponed.skincareIntoItems) || [])

  if (selectedItems.length) {
    actions.misc.localStorage.setItem(constants.localStorageNames.skincareIntroItems, selectedItems)
    actions.misc.cookies.removeItem(constants.cookieNames.postponed.skincareIntoItems)
  }
}

const setSelectedItemsFromStorage = () => {
  moveSelectedItemsFromCookieToStorage()

  const selectedItems = actions.misc.localStorage.getItem(constants.localStorageNames.skincareIntroItems, [])

  reducers.view.skincareIntroPage.setSelectedItems(selectedItems)
}

export default {
  selectItem,
  clearSelectedItems,
  setSelectedItemsFromStorage,
  fetchProducts,
}
